export const clamp = (x: number, min: number, max: number): number => (x < min ? min : x > max ? max : x);

export const saturate = (x: number): number => clamp(x, 0, 1);

export const lerp = (a: number, b: number, t: number): number => a + (b - a) * t;

export const invLerp = (a: number, b: number, x: number): number => (x - a) / (b - a);

export function smoothstep(edge0: number, edge1: number, x: number): number {
  const t = saturate((x - edge0) / (edge1 - edge0));
  return t * t * (3 - 2 * t);
}

/** 滑らかな最小値（k は角を丸める幅） */
export function smin(a: number, b: number, k: number): number {
  const h = saturate(0.5 + (0.5 * (b - a)) / k);
  return lerp(b, a, h) - k * h * (1 - h);
}

/** 滑らかな最大値 */
export function smax(a: number, b: number, k: number): number {
  return -smin(-a, -b, k);
}

export const degToRad = (d: number): number => (d * Math.PI) / 180;
export const radToDeg = (r: number): number => (r * 180) / Math.PI;

/** 角度を (-π, π] に正規化する */
export function wrapPi(a: number): number {
  let x = a % (2 * Math.PI);
  if (x <= -Math.PI) x += 2 * Math.PI;
  else if (x > Math.PI) x -= 2 * Math.PI;
  return x;
}

/** 2 つの方位の差（0〜π） */
export const angleDiff = (a: number, b: number): number => Math.abs(wrapPi(a - b));

/** 整数座標から [0, 1) の値を作るハッシュ（位置から決まる乱数） */
export function hash2(ix: number, iz: number, seed = 0): number {
  let h = Math.imul(ix, 0x27d4eb2d) ^ Math.imul(iz, 0x165667b1) ^ Math.imul(seed, 0x9e3779b1);
  h = Math.imul(h ^ (h >>> 15), 0x85ebca6b);
  h = Math.imul(h ^ (h >>> 13), 0xc2b2ae35);
  return ((h ^ (h >>> 16)) >>> 0) / 4294967296;
}
